import { addCmmEvent } from "../../../api/firebase/firestoreService";
import { getBearerToken } from "../../../api/postCall/bearerToken";
import { CoverMyMedsInputModel } from "../../../data-model/cmmInputRequestModel";
import { API_ENDPOINTS } from "../../../enums/apiUrls";
import { CmmEvents } from "../../../enums/cmmEvents";
import { ScreenNames } from "../../../enums/screenNames";
import { logDataToConsole, logError } from "../../../utils/customLogger";

const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getBearerToken();
  return {
    Authorization: `Bearer ${token}`,
  };
};

export const sendToPlanPrimaryCare = async (
  signal: AbortSignal,
  payload: CoverMyMedsInputModel,
  identifier: string,
  email?: string,
): Promise<any> => {
  try {
    const headers = await getAuthHeaders();

    // Log the event to Firebase
    addCmmEvent(identifier, {
      event: CmmEvents.SEND_TO_PLAN_INITIATED,
      screen_name: ScreenNames.PRIMARY_CARE_ORDERS,
      created_at: new Date(),
      email: email ?? "",
    });

    const requestOptions: RequestInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(payload),
      redirect: "follow",
      signal,
    };

    logDataToConsole("Send to Plan Request Payload", payload);

    const response = await fetch(
      API_ENDPOINTS.SEND_TO_PLAN_IN_CMM,
      requestOptions,
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    logDataToConsole("Send to Plan Response", result);

    return result;
  } catch (error) {
    logError(error as Error, "Error in sendToPlanPrimaryCare");
    throw error;
  }
};
